/**
 * `vh` resolves against the large viewport — the height the page would have with the browser
 * toolbar fully retracted — so while the toolbar is showing it overshoots the visible height.
 * Anything anchored to the bottom of a `100vh` box (the campaign creation dock) then lands below
 * the fold. `dvh` follows the viewport that is actually visible; `vh` remains the fallback for
 * engines without `dvh` support.
 */
const supportsDvh =
  typeof window !== 'undefined' && typeof window.CSS?.supports === 'function' && window.CSS.supports('height', '100dvh');

export const VIEWPORT_HEIGHT = supportsDvh ? '100dvh' : '100vh';

export default VIEWPORT_HEIGHT;
